'use client';

import { useEffect } from 'react';
import { useReportWebVitals } from 'next/web-vitals';
import { addVital, startTelemetry } from '@/lib/diagnostics/client';

// Speed and errors as real visitors meet them (lib/diagnostics/client.ts).
// Renders nothing.
export default function Telemetry() {
  useEffect(() => {
    startTelemetry();
  }, []);
  useReportWebVitals((metric) => {
    startTelemetry();
    addVital(metric.name, metric.value);
  });
  return null;
}
